module.exports = __webpack_public_path__ + "img/auto-targa.769b2acd.svg";